import axios from "axios";
import appService from "./app.service";

/**
 * @typedef {Object} ResponseError
 * @property {string} msg
 * @property {string} Error
 */

let current_token = appService.getAccessToken();

function validToken(access_token) {
  if (!access_token || access_token === "") return false;
  function JWTExpired(payload) {
    let expireDate = payload.exp * 1000;
    let now = Date.now();
    return now > expireDate;
  }
  let tokendata = JSON.parse(window.atob(access_token.split(".")[1]));
  return tokendata && !JWTExpired(tokendata);
}

function renewToken() {
  let refreshToken = localStorage.getItem("refresh_token");
  let codeVerifier = localStorage.getItem("code_verifier");
  let formData = new FormData();
  formData.append("client_id", "loopOpFrontend");
  formData.append("code_verifier", codeVerifier);
  formData.append("refresh_token", refreshToken);
  formData.append("grant_type", "refresh_token");
  let url = `${appService.getServerUrl()}connect/token`;
  return new Promise((resolve, reject) => {
    if (!refreshToken) {
      throw Error("no refreshToken or codeVerifier");
    }

    axiosInstanceAuth
      .post(url, formData)
      .then((res) => {
        let data = res.data;
        if (data && data.access_token && data.refresh_token && data.id_token) {
          appService.storeTokensInStorage(
            data.access_token,
            data.id_token,
            data.refresh_token
          );
          resolve(localStorage.getItem("access_token") || "yooo");
        } else {
          throw Error("Bad token response");
        }
      })
      .catch((err) => {
        console.error("Error on POST in renewToken()");
        reject(err);
      });
  });
}

const axiosInstance = axios.create({
  headers: {
    "Content-type": "application/json",
    Accept: "application/json, text/plain, */*",
  },
});
const axiosInstanceAuth = axios.create({
  headers: {
    "Content-type": "application/json",
    Accept: "application/json, text/plain, */*",
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    current_token = appService.getAccessToken();
    let access_token;
    if (validToken(current_token)) {
      access_token = current_token;
    } else {
      try {
        const refreshProcess = renewToken();
        access_token = await refreshProcess;
      } catch (err) {
        console.error("Token Renwal failed:", err);
        appService.removeTokensFromStorage();
        appService.directToLogin();
      }
      console.warn("Token has beed renewed");
    }
    config.headers = {
      Authorization: `Bearer ${access_token}`,
      Accept: "application/json",
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  /**
   *
   * @param {import('axios').AxiosResponse<T>} response
   * @returns {Promise<T|ResponseError>}
   */
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (!response.data) {
      return Promise.reject({
        msg: "We got a 200 OK with an empty response",
        Error: "EMPTY SERVER RESPONSE",
      });
    }
    if (response.data.Error) {
      return Promise.reject({
        msg: `Backendmsg: ${response.Error}`,
        Error: response.Error,
      });
    }
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/services/requestBase.js